<template>
  <div>
    <div class="">
      <div class="text-h5">Embed Tool Configuration Generator</div>
      <hr />

      <div class="q-pa-md" style="max-width: 400px">
      <q-form
          @submit="onSubmit"
          class="q-gutter-md"
      >
        <q-input filled
                 type="text"
                 v-model="url"
                 label="Embed Url"
                 lazy-rules
                 :rules="[
                  val => val !== null && val !== '' || 'Please insert the Embed Url'
                ]"
          />

          <div class="q-pr-md" style="max-width: 200px">
            <span class="text-h6">Location</span>
            <q-checkbox v-model="accountNav"
                      label="Account Navigation" />

            <q-checkbox v-model="courseNav"
                        label="Course Navigation" />

            <q-checkbox v-model="userNav"
                        label="User Navigation" />
          </div>
          <div>
            <q-btn label="Generate" type="submit" color="primary" class="q-mr-md" />
            <q-spinner v-if="isLoading"
                       color="primary"
                       size="3em" />
          </div>
        </q-form>
      </div>
    </div>
    <div v-if="error" class="row">
      <div class="col-12">
        <div class="text-red">
          {{ error }}
        </div>
      </div>
    </div>
    <div v-if="configUrl" class="row">
      <div class="col-12">
        <div class="text-subtitle2">

          <q-input
          type="text"
          v-model="configUrl"
          label="XML Configuration URL"
          dense
          readonly
          >
            <template v-slot:after>
              <q-btn round dense flat color="primary" icon="content_copy" @click="copyUrl" />
            </template>
          </q-input>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useQuasar } from 'quasar'

export default {
  name: 'config-generator',

  setup () {
    const configUrl = ref(null)

    const url = ref(null)
    const accountNav = ref(false)
    const courseNav = ref(false)
    const userNav = ref(false)
    const error = ref('')
    const isLoading = ref(false)
    const $q = useQuasar()

    const onSubmit = async () => {
      isLoading.value = true
      error.value = null
      configUrl.value = null

      const embedUrlEncoded = encodeURIComponent(url.value)

      const template = `${window.location.href}config?{accountNav}{courseNav}{userNav}{url}`
      configUrl.value =
        template.replace('{accountNav}', accountNav.value ? 'accountNav&' : '')
          .replace('{courseNav}', courseNav.value ? 'courseNav&' : '')
          .replace('{userNav}', userNav.value ? 'userNav&' : '')
          .replace('{url}', `url=${embedUrlEncoded}`)

      isLoading.value = false
    }

    const copyUrl = () => {
      navigator.clipboard.writeText(configUrl.value)
      $q.notify({ type: 'positive', message: 'Copied to clipboard!', position: 'bottom-left' })
    }

    return {
      configUrl,
      url,
      accountNav,
      courseNav,
      userNav,
      error,
      isLoading,
      onSubmit,
      copyUrl
    }
  }
}
</script>
